<template>
    <div>
        <div class="header pd-bot-base">
            <div class="container">
                <div class="header-wrapper">
                    <div class="header-logo">
                        <a href="/">
                            <img v-show="header_logo" src="../../assets/img/headerlogo.svg" alt="LunarBase"/>
                        </a>
                    </div>
                    <div class="header-menu">
                        <a class="active" href="/">HOME</a>
                        <a href="#aboutgame">THE GAME</a>
                        <a href="https://www.facebook.com/lunarbasegame/">SOCIAL</a>
                        <a class="outline-menu" href="https://shop.plepic.com">BUY</a>
                    </div>
                    <div class="nav-icon" @click="toggleMobileMenu">
                        <div :class="{ div1_active: mobileMenuState }" class="div1"></div>
                        <div :class="{ div2_active: mobileMenuState }" class="div2"></div>
                        <div :class="{ div3_active: mobileMenuState }" class="div3"></div>
                    </div>
                    <hamMenu data-aos="fade-left" v-if="mobileMenuState"></hamMenu>
                </div>
            </div>
            <div class="container">
                <div class="wrapper justify-between mr-top-150 align-center">
                    <div class="header-heading">
                        <img class="heading-img" style="margin-left: -10px;" src="../../assets/img/h_lunarbase1.svg"
                             alt="LunarBase"/>
                        <div class="wrapper align-center">
                          <p>Our Kickstarter project has ended with great success!</p>
                        </div>
                        <div class="wrapper align-center">
                          <p>Late pledge is available on our e-shop.</p>
                        </div>
                        <a class="outline mr-top-xs" href="https://shop.plepic.com">GO TO SHOP</a>
                        <a class="outline mr-top-xs" href="https://www.kickstarter.com/projects/hugphones/lunar-base-a-moon-colonization-base-building-card-game">KICKSTARTER PROJECT <img src="../../assets/img/ks.svg"/></a>
                    </div>
                    <img class="lunar-logo" src="../../assets/img/small-logo.svg" alt="LunarBase"/>
                </div>
                <div class="mobile-heading-block">
                  <div class="wrapper align-center">
                    <p>Our Kickstarter project has ended with great success!</p>
                  </div>
                  <div class="wrapper align-center">
                    <p>Late pledge is available on our e-shop.</p>
                  </div>
                  <a class="outline mr-top-xs" href="https://shop.plepic.com">GO TO SHOP</a>
                  <a class="outline mr-top-xs" href="https://www.kickstarter.com/projects/hugphones/lunar-base-a-moon-colonization-base-building-card-game">KICKSTARTER PROJECT <img src="../../assets/img/ks.svg" alt="arrow"/></a>
                </div>
            </div>
        </div>
        <a name="video_trailer" />
        <div class="video-block pd-bot-base">
            <div class="divider"></div>
            <div class="container">
                <div class="wrapper flex-column pd-top-base">
                    <div class="wrapper align-center justify-center mobile-wrapper">
                        <img class="h_gametrailer" src="../../assets/img/h_gametrailer.svg" alt="LunarBase"/>
                        <h1>Lunar Base is a base-building strategy game, a moon colonization space race.</h1>
                    </div>
                    <div class="video-responsive pd-top-sm">
                        <iframe ref="youtubeVideo" style='height: 640px; width: 1082px; margin: 0 auto; display:block;' frameborder="0" scrolling="no" allowfullscreen
                                src="https://www.youtube.com/embed/2D_y7t7DDYM">
                        </iframe>
                    </div>
                    <div class="wrapper justify-center mobile-wrapper">
                      <a href="#video_trailer" class="video-thumbnail" style="padding-left: 0;" v-on:click="changeVideo($event, '2D_y7t7DDYM')"><img src="../../assets/img/kstrailer.jpg" alt="Trailer"/><br/>Trailer</a>
                      <a href="#video_trailer" class="video-thumbnail" v-on:click="changeVideo($event, 'QZ_Pqf3eY4o')"><img src="../../assets/img/teaser_1.jpg" alt="Teaser part 1"/><br/>Teaser: part 1</a>
                      <a href="#video_trailer" class="video-thumbnail" v-on:click="changeVideo($event, 'KSuIqu5qzTM')"><img src="../../assets/img/teaser_2.jpg" alt="Teaser part 2"/><br/>Teaser: part 2</a>
                      <a href="#video_trailer" class="video-thumbnail" v-on:click="changeVideo($event, 'JjlDpS2ByXY')"><img src="../../assets/img/teaser_3.jpg" alt="Teaser part 3"/><br/>Teaser: part 3</a>
                      <a href="#video_trailer" class="video-thumbnail" v-on:click="changeVideo($event, 'v0lS1aenCXU')"><img src="../../assets/img/teaser_4.jpg" alt="Teaser part 4"/><br/>Teaser: part 4</a>
                    </div>
                    <div class="wrapper align-center justify-center">
                      <a class="outline mr-top-xs" href="https://shop.plepic.com">GO TO SHOP</a>
                    </div>

                </div>
            </div>
        </div>

        <a name="aboutgame" />
        <div class="block-about pd-top-base pd-bot-base">
            <div class="container">
                <img class="h_about" src="../../assets/img/h_aboutthegame.svg" alt="LunarBase"/>
                <div class="wrapper mobile-wrapper pd-top-xs">
                    <div class="wrapper flex-column textcolumn">
                        <div class="textbox">
                            <p>A bold new era of space exploration has begun. With many different factions and
                                organizations vying for power in this latest space race, you are tasked with leading one
                                of
                                these competing moon colonization teams.</p>
                        </div>
                        <div class="textbox pd-top-xs">
                            <p>
                                Establish your lunar station and construct powerful modules to expand your base.</p>
                        </div>
                    </div>
                    <div class="wrapper flex-column">
                        <div class="textbox">
                            <p>Make
                                shipments from Earth work to your advantage. Recruit agents and send them to infiltrate
                                opponents' bases to hasten your expansion, or hinder the progress of your
                                competitors.</p>
                        </div>
                        <div class="textbox pd-top-xs">
                            <p>
                                Defeat your rivals and achieve lunar dominance by housing the most colonists, gaining
                                the
                                most influence, hoarding the most lunar credits, or earning the most renown through
                                scientific achievements.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="block-cards">
            <div class="container">
                <img class="cards" src="../../assets/img/cards.png" alt="LunarBase"/>
                <img class="mobilecards" src="../../assets/img/mobilecards.png" alt="LunarBase"/>
                <img class="bigcards" src="../../assets/img/bigcards.png" alt="LunarBase"/>
                <div style="text-align: right">
                    <img class="cardsdown" src="../../assets/img/cardsdown.png" alt="LunarBase"/>
                </div>
            </div>
        </div>

        <div class="block-features pd-top-base pd-bot-base">
            <div class="container">
                <img class="h_features" src="../../assets/img/h_features.svg" alt="LunarBase"/>
                <div class="wrapper justify-center mobile-wrapper pd-top-sm">
                    <div class="feature-column">
                        <img src="../../assets/img/firstplaced.svg" alt="LunarBase"/>
                        <div class="head">Fast-paced</div>
                        <p>Games take on average 30 min. Enjoy it on a break!</p>
                    </div>
                    <div class="feature-column">
                        <img src="../../assets/img/reply.svg" alt="LunarBase"/>
                        <div class="head">Replayable</div>
                        <p>Each game is unique.
                            Add additional cards or alternate rules.</p>
                    </div>
                    <div class="feature-column">
                        <img src="../../assets/img/quick.svg" alt="LunarBase"/>
                        <div class="head">Quick Start</div>
                        <p>Learn it in 20 min. Setup in 1 min.</p>
                    </div>
                    <div class="feature-column">
                        <img src="../../assets/img/port.svg" alt="LunarBase"/>
                        <div class="head">Portable</div>
                        <p>Travel sized to fit in your pocket. Take it anywhere!</p>
                    </div>
                    <div class="feature-column">
                        <img src="../../assets/img/playerinfo.svg" alt="LunarBase"/>
                        <div class="head">Player info</div>
                        <p>2 - 6 players <br>Age 10 +</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="block-form pd-top-base pd-bot-base">
            <div class="container">
                <div class="wrapper align-center">
                  <a href="https://www.kickstarter.com/projects/hugphones/lunar-base-a-moon-colonization-base-building-card-game">
                    <img class="header_block_1 mr-rt-xs" src="../../assets/img/ks-fully-funded.svg" alt="LunarBase"/>
                  </a>
                </div>
              <div class="wrapper mr-top-xs align-center">
                <a href="https://shop.plepic.com"><img class="header_block_1 mr-rt-xs" src="../../assets/img/go-to-shop.svg" alt="LunarBase"/></a>
              </div>
                <div class="wrapper mr-top-xs align-center">
                    <img class="header_block mr-rt-xs" src="../../assets/img/h_followuson.svg" alt="LunarBase"/>
                    <a href="https://www.facebook.com/lunarbasegame/"> <img class="social" src="../../assets/img/fb.svg" alt="LunarBase"/></a>
                    <a href="https://twitter.com/LunarBaseGame"> <img class="social" src="../../assets/img/twi.svg" alt="LunarBase"/></a>
                    <a href="https://www.instagram.com/lunarbasegame/"> <img class="social" src="../../assets/img/inst.svg" alt="LunarBase"/></a>
                    <a href="https://www.youtube.com/channel/UCl88HwyWs3a5pT4A4ibQAMA"> <img class="social" src="../../assets/img/yout.svg" alt="LunarBase"/></a>
                </div>
            </div>
        </div>


        <div class="footer pd-top-sm pd-bot-sm">
            <div class="container">
                <div class="wrapper justify-between align-center mobile-wrapper">
                    <div class="footer-menu wrapper">
                        <div class="footer-logo-mobile-block" style="margin-top: 20px">
                            <img class="safari_logo" src="../../assets/img/small-logo.svg" alt="LunarBase"/>
                        </div>
                        <a class="active" href="/">HOME</a>
                        <a href="#aboutgame">THE GAME</a>
                        <a href="https://www.facebook.com/lunarbasegame/">SOCIAL</a>
                        <a href="https://shop.plepic.com">BUY</a>
                    </div>
                    <div class="footer-logo">
                        <img src="../../assets/img/small-logo.svg" alt="LunarBase"/>
                    </div>
                    <div class="wrapper footer-media mobile-wrapper">
                        <a href="https://twitter.com/LunarBaseGame"> <img class="social" src="../../assets/img/twi.svg" alt="LunarBase"/></a>
                        <a href="https://www.instagram.com/lunarbasegame/"> <img class="social" src="../../assets/img/inst.svg" alt="LunarBase"/></a>
                        <a href="https://www.youtube.com/channel/UCl88HwyWs3a5pT4A4ibQAMA"> <img class="social" src="../../assets/img/yout.svg" alt="LunarBase"/></a>
                        <a href="https://www.kickstarter.com/projects/hugphones/lunar-base-a-moon-colonization-base-building-card-game"> <img class="social" src="../../assets/img/ks.svg" alt="LunarBase"/></a>
                        <a href="https://www.facebook.com/lunarbasegame/"> <img class="social" src="../../assets/img/fb.svg" alt="LunarBase"/></a>
                        <img class="footerlogo" src="../../assets/img/footerlogo.svg" alt="LunarBase"/>
                    </div>
                </div>
                <div class="wrapper footer-media-mobile mobile-wrapper align-center">
                    <a href="https://twitter.com/LunarBaseGame"> <img class="social" src="../../assets/img/twi.svg" alt="LunarBase"/></a>
                    <a href="https://www.instagram.com/lunarbasegame/"> <img class="social" src="../../assets/img/inst.svg" alt="LunarBase"/></a>
                    <a href="https://www.youtube.com/channel/UCl88HwyWs3a5pT4A4ibQAMA"> <img class="social" src="../../assets/img/yout.svg" alt="LunarBase"/></a>
                    <a href="https://www.kickstarter.com/projects/hugphones/lunar-base-a-moon-colonization-base-building-card-game"> <img class="social social" src="../../assets/img/ks.svg" alt="LunarBase"/></a>
                    <a href="https://www.facebook.com/lunarbasegame/"> <img class="social" src="../../assets/img/fb.svg" alt="LunarBase"/></a>
                    <img class="footerlogo" src="../../assets/img/footerlogo.svg" alt="LunarBase"/>
                </div>
                <div class="mobile-logo-block">
                    <img src="../../assets/img/footerlogo.svg" alt="LunarBase"/>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import hamMenu from "../site-elements/ham-menu"

    export default {
        name: "index-main",
        components: {
            hamMenu
        },
        data() {
            return {
                header_logo: true
            }
        },
        methods: {
            toggleMobileMenu() {
                if (this.mobileMenuState === false) {
                    this.$store.commit("setShowMobileMenu")
                    if (window.matchMedia("(orientation: landscape)").matches) {
                        this.header_logo = false
                    }
                } else {
                    this.$store.commit("setHideMobileMenu")
                    this.header_logo = true
                }
            },
            changeVideo(event, videoCode) {
              event.preventDefault()
              this.$refs.youtubeVideo.src = 'https://www.youtube.com/embed/' + videoCode
            }
        },
        computed: {
            mobileMenuState() {
                return this.$store.state.showMobileMenu
            }
        },
        watch: {
            mobileMenuState() {
                document.body.style.overflow = this.mobileMenuState ? 'hidden' : ''
            },
            header_logo() {
                this.header_logo = !(this.mobileMenuState === true && (window.matchMedia("(orientation: landscape)").matches));
            }
        },
    }
</script>
